import {
  BaseEvent,
  EventProductInCart,
  EventNavigationMenu,
  EventHeroCarousel,
  EventCardsSliderNavigation,
  PageLoadEvent,
  EventFormInteractRequest,
  EventOrderListRowAction,
  EventCommunicationError,
} from '../models';

export const dynamicLinkClick = (event: BaseEvent) => {
  return {
    wa_lnk: lowercaseFirstLetter(`${toCamelCase(event.item)}_${toCamelCase(event.component)}`),
    wa_tp: 1,
  };
};

export const hover = (event: BaseEvent) => {
  return {
    wa_hov_n: lowercaseFirstLetter(toCamelCase(event.component)),
    wa_hov_d: lowercaseFirstLetter(toCamelCase(event.item)),
    wa_tp: 12,
  };
};

export const formInteractionAddToCart = (event: EventProductInCart | any) => {
  return {
    wa_frm_n: lowercaseFirstLetter(`${toCamelCase(event.component)}`),
    wa_frm_s: lowercaseFirstLetter(
      [toCamelCase(event.item), event.order, event.position].filter((value) => !!value).join('_'),
    ),
    wa_tp: 8,
  };
};

export const dynamicLinkClickWithPosition = (
  event: EventNavigationMenu | EventHeroCarousel | EventCardsSliderNavigation,
) => {
  return {
    wa_lnk: lowercaseFirstLetter(
      [toCamelCase(event.item), toCamelCase(event.component), event.position].filter(Boolean).join('_'),
    ),
    wa_tp: 1,
  };
};

export const pageLoad = (event: PageLoadEvent) => {
  return {
    pg_name: lowercaseFirstLetter(toCamelCase(event.screenName)),
  };
};

export const formInteractionWithPosition = (event: EventFormInteractRequest): Record<string, any> => {
  return {
    wa_frm_n: toCamelCase(event.component),
    wa_frm_s: [
      lowercaseFirstLetter(toCamelCase(event.formName) ?? toCamelCase(event.item)),
      lowercaseFirstLetter(toCamelCase(event.fieldName)),
      event.position,
      event._isIncludeValue ? event.value : null,
    ]
      .filter((value) => !!value)
      .join('_'),
    wa_tp: 8,
  };
};

export const orderListRowInteraction = (event: EventOrderListRowAction | any): Record<string, any> => {
  return {
    wa_frm_n: lowercaseFirstLetter(toCamelCase(event.component)),
    wa_frm_s: lowercaseFirstLetter(
      [toCamelCase(event.item), event.order, event.position].filter((value) => !!value).join('_'),
    ),
    wa_tp: 8,
  };
};

export const externalLinkClick = (event: BaseEvent) => {
  return { wa_exlnk: event.externalLink, wa_tp: 3 };
};

export const modalEvent = (event: BaseEvent | any) => {
  return {
    wa_dyn_n: lowercaseFirstLetter(toCamelCase(event.component)),
    wa_dyn_d: lowercaseFirstLetter([toCamelCase(event.item), event.position].filter((value) => !!value).join('_')),
    wa_tp: 9,
  };
};

export const communicationError = (event: EventCommunicationError) => {
  return {
    jp_ct: 'error',
    jp_cn: 'sac_error',
    jp_cc: 'system_driven',
    jp_cms: event.cms,
    jp_csr: event.csr,
    et: 22,
  };
};

export function toCamelCase(text: string | null): string {
  return (text ?? '')
    .toLowerCase() // Convert the whole text to lowercase
    .replace(/[_\-\s]+([a-zA-Z])/g, (_, chr) => chr.toUpperCase()); // Replace non-alphanumeric characters and capitalize the next letter
}

function lowercaseFirstLetter(text: string): string {
  if (!text) return text; // Return as-is if the string is empty
  return text.charAt(0).toLowerCase() + text.slice(1);
}
